import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { UnprocessedEntitiesCards } from '../../unprocessed-entities';

export const entityContentUnprocessedEntities: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'unprocessed-entities',
    params: {
      path: '/unprocessed-entities',
      title: 'Unprocessed Entities',
      filter: { kind: 'Group' },
      loader: async () => <UnprocessedEntitiesCards />,
    },
  });
